// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m5-3";
export var downloadButton = "_m5-4";
export var fileContainer = "_m5-9 _m5-7";
export var fileContainerBase = "_m5-7";
export var fileContainerFixedHeight = "_m5-8 _m5-7";
export var fileInfo = "_m5-5";
export var fileInfoWidthRestricted = "_m5-6";
export var fileType = "_m5-1";
export var fileTypeName = "_m5-2";
export var image = "_m5-0";
export var link = "_m5-b";
export var overflowEllipsis = "_m5-a";